
function scrollButton($button) {
    let clickHandler;

    return {
        reset: () => {
            if (clickHandler) {
                $button.removeEventListener('click', clickHandler);
            }

            $button.removeAttribute('disabled');
            $button.style.removeProperty('display');
        },
        onClick: (clickHandler) => {
            $button.addEventListener('click', clickHandler);
        },
        enable: () => {
            $button.disabled = false;
        },
        disable: () => {
            $button.disabled = true;
        },
        show: () => {
            $button.style.display = 'initial';
        },
        hide: () => {
            $button.style.display = 'none';
        }
    };
}

export default function comparisonScrollController({ $scrollarea, $columns, $next, $previous }) {
    if (!$scrollarea || !$columns || !$next || !$previous) {
        throw new Error('comparisonScrollController requires more properties');
    }

    const next = scrollButton($next);
    const previous = scrollButton($previous);

    const setButtonDisabledState = () => {
        previous[$scrollarea.scrollLeft === 0 ? 'disable' : 'enable']();
        next[$scrollarea.scrollLeft === $scrollarea.scrollWidth - $scrollarea.clientWidth ? 'disable' : 'enable']();
    };

    const requiresHorizontalScroll = () => $scrollarea.scrollWidth > $scrollarea.clientWidth;

    const setButtonVisibility = (hasOverflow) => {
        next[hasOverflow ? 'show' : 'hide']();
        previous[hasOverflow ? 'show' : 'hide']();
    };

    const scrollTo = ($element) => {
        if (!$element) {
            return;
        }

        $scrollarea.scrollTo({
            left: $element.offsetLeft,
            behavior: 'smooth'
        });
    };

    previous.onClick(() => scrollTo($columns.find($column => $column.offsetLeft > ($scrollarea.scrollLeft - $scrollarea.clientWidth))));

    next.onClick(() => scrollTo($columns.find($column => $column.offsetLeft + $column.clientWidth > ($scrollarea.scrollLeft + $scrollarea.clientWidth))));

    setButtonVisibility(requiresHorizontalScroll());
    setButtonDisabledState();

    const handleScroll = () => {
        if ($scrollarea.scrollWidth <= $scrollarea.clientWidth) {
            return;
        }

        setButtonDisabledState();
    };   

    const handleResize = () => {
        setButtonVisibility(requiresHorizontalScroll());
        setButtonDisabledState();
    };

    $scrollarea.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return {
        forceUpdate: () => handleResize()
    };
}